import React, { useState } from "react";

const FileUploadComponent = ({ setFieldValue, setFieldTouched }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const handleFileChange = (event) => {
    setFieldTouched("file");
    handleFile(event.target.files[0]);
  };

  const handleDragOver = (event) => {
    setFieldTouched("file");
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    handleFile(file);
  };

  const handleFile = (file) => {
    if (file) {
      // Check file size (in bytes)
      //const maxSize = 1024 * 1024; // 1MB
      //   if (file.size > maxSize) {
      //     alert("File size exceeds the maximum allowed size (1MB).");
      //     return;
      //   }

      //   // Check file type
      //   if (!file.type.startsWith("image/")) {
      //     alert("Invalid file type. Please upload an image.");
      //     return;
      //   }

      // Read and set the preview image
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);

      // Set the selected file
      setSelectedFile(file);
      setFieldValue("file", file);
    }
  };

  return (
    <div
      className="file-upload-container"
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <label className="file-upload-label">
        <input
          name="file"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
        Upload License Document
      </label>
      <p>or</p>
      <p>Drag and drop your license document here</p>
      {previewImage && (
        <img src={previewImage} alt="Preview" className="preview-image" />
      )}
    </div>
  );
};

export default FileUploadComponent;
